import "../../woocommerce/js/tabs";